export default function Sugar() {
  return (
    <section id="sugar" className="commodities">
      <div className="container">
        <div className="section-title">
          <h2>Sugar</h2>
          <p>
            <span>FMI</span> Sugar
          </p>
        </div>
        <div className="row">
          <div className="col-lg-4 d-none d-lg-inline">
            <img src="/assets/img/cover-images/sugar_cover.png" className="img-fluid" alt="sugar cover" style={{height: "100%"}}/>
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content">
            {/* <h3 className="commodities-title">Sumary</h3> */}
            <div className="commodities-item">
              {/* <h4>Alice Barkley</h4>s */}
              <p>
                <em>
                  Discover the world of sugar with Fund Marketing International (FMI).
                  We offer comprehensive indenting and brokerage services for sugar exports in Pakistan,
                  representing global commodity merchants and facilitating the sale of sugar to Afghanistan and other regional nations.
                </em>
              </p>
              <p>
                <em>
                  Benefit from our strong partnerships with sugar mills factories nationwide and with neighboring countries,
                  FMI works with local sugar mills to ensure smooth operations.
                  Our team closely monitors both local and international sugar markets, providing invaluable insights into market dynamics.
                </em>
              </p>
            </div>

            {/* <h3 className="commodities-title">Education</h3> */}
            <div className="commodities-item">
              <p style={{color: "#FFB03B", fontWeight: "bold", textTransform: "capitalize",}}>
                Trust our trained agronomists for local sugarcane crop surveys and farm advisory services.
                Stay informed with our daily, weekly, and seasonal reports covering
                the latest developments in the cotton and textile sector, including:
              </p>
              <ul>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Daily Pakistan Sugar Market Report
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Daily Sugar Mills Price Report
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Daily Jodia Bazaar and Akbari Mandi Price Report
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Daily Afghanistan Sugar Market Report
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Monthly Global Demand-Supply Analysis
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Seasonal Sugarcane Crop Survey Reports
                </li>
              </ul>
            </div>
            <div className="commodities-item">
              {/* <h4>Bachelor of Fine Arts &amp; Graphic Design</h4>
              <h5>2010 - 2014</h5>
              <p><em>Rochester Institute of Technology, Rochester, NY</em></p> */}
              <p>
                Ready to explore opportunities in the sugarcane and sugar industry?
                {/* <br />
                <span style={{color: "#FFB03B", fontWeight: "bold", textTransform: "capitalize"}}>
                  Contact us
                </span> today for more information! */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
